/** On an animal's Records tab: where its first record came from, with the original row. */
import { Link } from "react-router";
import type { AnimalDetail } from "../../../contract";
import { formatDate } from "../../../web/lib/format";
import { t, useLanguage } from "../../../web/lib/i18n";
import { useApi } from "../../../web/lib/query";
import { useCan } from "../../../web/lib/session";
import { Card, Disclosure, Loading } from "../../../web/ui/kit";
import { sourceName } from "./labels";

interface Item { source: string; import: { id: string; title: string; created_at: string; status: string } | null; file: string | null; row: number | null; cells: Record<string, string> | null; imported_at: string }

export function ProvenanceSection({ animal }: { animal: AnimalDetail }) {
  useLanguage();
  const can = useCan();
  const q = useApi<{ items: Item[] }>(`/m/data/provenance/animal/${animal.id}`);
  if (q.isLoading) return <Loading />;
  const items = q.data?.items ?? [];
  if (!items.length) return <p className="muted">{t("Brought in from a file. The import it came from was undone or removed.")}</p>;
  return (
    <div className="stack">
      {items.map((i, n) => (
        <Card key={n}>
          <p>{t("From {{source}}", { source: sourceName(i.source) })}{i.file ? ` · ${i.file}` : ""}{i.row ? ` · ${t("row {{row}}", { row: i.row })}` : ""} · {formatDate(i.imported_at.slice(0, 10))}</p>
          {i.import && can("data") && <p><Link to={`/ranch/data/imports/${i.import.id}`}>{i.import.title}</Link></p>}
          {i.cells && Object.keys(i.cells).length > 0 && (
            <Disclosure label={t("The original row")}>
              <dl className="data-list">{Object.entries(i.cells).map(([k, v]) => <div key={k}><dt>{k}</dt><dd>{v}</dd></div>)}</dl>
            </Disclosure>
          )}
        </Card>
      ))}
    </div>
  );
}

export const showProvenance = (a: AnimalDetail): boolean => a.origin === "imported" || Object.keys(a.attrs ?? {}).some((k) => !k.includes("."));
